// extracted by mini-css-extract-plugin
export default {"body":"styles_body__xlRqM","content":"styles_content__g5EUs","text":"styles_text__pOlkX","cta":"styles_cta__q3vQA","header":"styles_header__rI-oK"};